import Logout from '@mui/icons-material/Logout';
import {
  AppBar,
  Grid,
  ListItemButton,
  ListItemIcon,
  Toolbar,
} from '@mui/material';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { adminLogout } from 'store/actions';

const Header = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(adminLogout());
  };

  return (
    <AppBar color="primary" position="sticky" elevation={0}>
      <Toolbar>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs />

          <Grid item>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              Logout
            </ListItemButton>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
